import { aiTextToQuillHtml, renderQuillHtml } from "configs/utils";
import { useGetRewriteThroughAiMutation } from "features/script/api";
import { useState, useRef, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import Button from "../button/button";
import Modal from "../modal/modal";

const AiRewrite = ({ toolbarHeight, value, onChange }) => {
  const [getRewriteThroughAi, { isLoading: isRewriteLoading }] =
    useGetRewriteThroughAiMutation();
  const [rewrittenText, setRewrittenText] = useState("");
  const modalRef = useRef();

  const onAiRewrite = async () => {
    const res = await getRewriteThroughAi({ text: value });
    if (res?.data?.rewrittenText) {
      setRewrittenText(aiTextToQuillHtml(res.data.rewrittenText));
      modalRef.current?.setVisible(true);
    }
  };

  const handleAcceptRewrite = () => {
    onChange(rewrittenText);
    modalRef.current?.setVisible(false);
  };

  const handleKeepOriginal = () => {
    modalRef.current?.setVisible(false);
  };

  return (
    <>
      <Modal
        ref={modalRef}
        title="AI Rewrite Comparison"
        onOk={handleAcceptRewrite}
        onCancel={handleKeepOriginal}
        okText="Accept AI Rewrite"
        cancelText="Keep Original"
        width={1300}
        style={{ 
          top: 20,
          maxHeight: "80vh",
          minHeight: "40vh",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            gap: "24px",
            padding: "20px 0",
          }}
        >
          <div
            style={{
              flex: 1,
              backgroundColor: "#f8f9fa",
              border: "1px solid #e9ecef",
              borderRadius: "12px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              maxHeight: "300px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#6c757d",
                marginBottom: "12px",
              }}
            >
              Current Text
            </div>
            <div
              style={{
                flex: 1,
                fontSize: "14px",
                lineHeight: "1.5",
                color: "#495057",
                whiteSpace: "pre-wrap",
                overflow: "auto",
              }}
            >
              {renderQuillHtml(value, undefined, {
                fontSize: "14px",
                paddingLeft: "0px",
                paddingTop: "0px",
              }) || "No text to rewrite"}
            </div>
          </div>

          {/* Arrow */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#6c757d",
              fontSize: "20px",
            }}
          >
            <FaArrowRight />
          </div>

          <div
            style={{
              flex: 1,
              backgroundColor: "#f0f8ff",
              border: "1px solid #b3d9ff",
              borderRadius: "12px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              maxHeight: "300px",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#6c757d",
                marginBottom: "12px",
              }}
            >
              AI Rewritten Text
            </div>
            <div
              style={{
                flex: 1,
                fontSize: "14px",
                lineHeight: "1.5",
                color: "#495057",
                whiteSpace: "pre-wrap",
                overflow: "auto",
              }}
            >
              {renderQuillHtml(rewrittenText, undefined, {
                fontSize: "14px",
                paddingLeft: "0px",
                paddingTop: "0px",
              }) || "Generating AI rewrite..."}
            </div>
          </div>
        </div>
      </Modal>
      <div
        style={{
          position: "absolute",
          bottom: toolbarHeight ? `24px` : "8px",
          right: "8px",
          zIndex: 10,
        }}
      >
        <Button
          text={"AI Rewrite"}
          type="bordered"
          size="small"
          icon={"WiStars"}
          loading={isRewriteLoading}
          style={{
            background:
              "linear-gradient(135deg, #8B5CF6 0%, #7C3AED 50%, #6D28D9 100%)",
            border: "none",
            color: "white",
            borderRadius: "20px",
            padding: "4px 12px",
            boxShadow: "0 2px 8px rgba(139, 92, 246, 0.3)",
            fontSize: "12px",
            fontWeight: "500",
          }}
          onClick={onAiRewrite}
        />
      </div>
    </>
  );
};

export default AiRewrite;
